














































































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import DepthsForm from '@/components/forms/DepthsForm/DepthsForm.vue';
import SampleForm from '@/components/forms/SampleForm/SampleForm.vue';
import { SettingsService } from '@/services/storageService';
import { useEditSample } from '@/store/modules/samples';
import { Location, Sample, Sampling, SamplingCollection, SoDepth } from '@/store/types';
import { localizeDistance } from '@/views/sampling-collection/helpers';

export default defineComponent({
	props: {
		sampling: {
			type: Object as () => Sampling,
			required: true,
		},
		samplingCollection: {
			type: Object as () => SamplingCollection,
			required: true,
		},
		samples: {
			type: Array as () => Sample[],
		},
		location: {
			type: Object as () => Location,
		},
		submitted: {
			type: Boolean,
		},
	},
	components: {
		DepthsForm,
		SampleForm,
	},
	setup(props, { root, emit }) {
		const dialogIsVisible = ref<boolean>(false);
		const activeSample = ref<Sample>();
		const timestamp = computed<string>(() => new Date(props.sampling.resultTime).toLocaleString());
		const { clearError } = useEditSample(root.$store);
		const distanceUnit = SettingsService.getDistanceUnit();

		function onSetSamplingDepths(depths: SoDepth[]) {
			emit('setSamplingDepth', depths[0]);
		}

		function onCommentInput(value: string) {
			emit('setSamplingComment', value);
		}

		function onSampleAddClick() {
			// Set activeSample as undefined so that SampleForm will create new sample
			activeSample.value = undefined;
			dialogIsVisible.value = true;
		}

		function onSetSample(sample: Sample) {
			if (!props.submitted) {
				emit('setSamplingResult', sample);
			}
			dialogIsVisible.value = false;
		}

		function onSamplingCancel() {
			emit('samplingCancel');
		}

		function onSamplingSave() {
			emit('samplingSave', {
				sampling: props.sampling,
				samples: props.samples || [],
			});
		}

		function onSampleSelect(sample: Sample) {
			activeSample.value = sample;
			dialogIsVisible.value = true;
		}

		function onDeleteSample(id: string) {
			activeSample.value = undefined;
			emit('deleteSample', id);
			dialogIsVisible.value = false;
		}

		watch(
			() => dialogIsVisible.value,
			() => {
				clearError();
			}
		);

		return {
			onSetSamplingDepths,
			onCommentInput,
			onSampleAddClick,
			dialogIsVisible,
			onSetSample,
			onSamplingSave,
			onSamplingCancel,
			onSampleSelect,
			activeSample,
			onDeleteSample,
			timestamp,
			distanceUnit,
			localizeDistance,
		};
	},
});
